import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LoadingScreen({ logoUrl, onDone }) {
  const [stage, setStage] = useState(0);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("lostdc_seen_loader");
    const fast = !!seen;
    const t1 = setTimeout(() => setStage(1), fast ? 400 : 900);
    const t2 = setTimeout(() => setStage(2), fast ? 900 : 1900);
    const t3 = setTimeout(() => {
      setHide(true);
      sessionStorage.setItem("lostdc_seen_loader", "1");
      setTimeout(onDone, 500);
    }, fast ? 1400 : 2700);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!hide && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center overflow-hidden"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="absolute inset-0 tricolor-glow" />
          <div className="absolute inset-0 chakra-watermark opacity-60" />
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 120, damping: 14 }}
            className="relative z-10 flex flex-col items-center"
          >
            {logoUrl ? (
              <div className="w-24 h-24 rounded-2xl bg-[#0b1f3a] flex items-center justify-center shadow-lg mb-6 animate-pulse-ring">
                <img src={logoUrl} alt="LosTDRKC" className="w-20 h-20 object-contain" />
              </div>
            ) : (
              <div className="w-24 h-24 rounded-2xl bg-[#003366] text-white flex items-center justify-center text-3xl font-black font-heading shadow-lg mb-6 animate-pulse-ring">
                L
              </div>
            )}
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: stage >= 1 ? 1 : 0, y: stage >= 1 ? 0 : 12 }}
              transition={{ duration: 0.4 }}
              className="text-2xl md:text-3xl font-black font-heading tracking-tight text-slate-900"
            >
              LosTDRKC <span className="text-[#FF9933]">QUIZ</span>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: stage >= 2 ? 1 : 0, y: stage >= 2 ? 0 : 10 }}
              transition={{ duration: 0.4 }}
              className="text-xs md:text-sm font-bold tracking-[0.35em] text-slate-500 mt-2 uppercase"
            >
              Independence Day Special
            </motion.div>
            <div className="mt-8 w-56 h-1.5 rounded-full overflow-hidden flex">
              <div className="h-full flex-1 bg-[#FF9933]/30 relative overflow-hidden">
                <div className="absolute inset-y-0 w-1/3 bg-[#FF9933] animate-loader-bar" />
              </div>
              <div className="h-full flex-1 bg-slate-100 relative overflow-hidden">
                <div className="absolute inset-y-0 w-1/3 bg-slate-300 animate-loader-bar" style={{ animationDelay: "0.15s" }} />
              </div>
              <div className="h-full flex-1 bg-[#138808]/30 relative overflow-hidden">
                <div className="absolute inset-y-0 w-1/3 bg-[#138808] animate-loader-bar" style={{ animationDelay: "0.3s" }} />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
